<template>
  <card card-body-classes="table-full-width">
    <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <h4 slot="header" class="card-title">{{ $t('accountInspectionEvents.title') }}</h4>
    </div>
    <inspection-events-table :per-account="true"/>
  </card>
</template>

<script>
import InspectionEventsTable from "@/components/InspectionEvent/InspectionEventsTable";

export default {
  name: 'account-inspection-events',
  components: {InspectionEventsTable},
};
</script>
